/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, Input, InputSignal, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScrollCardDirective } from 'src/app/directives/scroll-card/scroll-card.directive';
import { ScrollCardModule } from 'src/app/directives/scroll-card/scroll-card.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SendUpdateRouteService } from '../send-update-route.service';

@Component({
  selector: 'cicerone-add-pdf',
  standalone: true,
  imports: [CommonModule, TranslateModule, SharedModule, ScrollCardModule],
  templateUrl: './add-pdf.component.html',
  styleUrls: ['./add-pdf.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddPdfComponent {
    @ViewChild('scrollDirective') scrollDirective!: ScrollCardDirective;
    public categories: InputSignal<any> = input.required<any>();
    public showBackButton: InputSignal<boolean> = input<boolean>(false);
    public translate = inject(TranslateService)
    private route = inject(ActivatedRoute)
    private sendUpdateService = inject(SendUpdateRouteService);
    public selectedPdfs = computed(() => this.sendUpdateService?.userData()?.pdfs || [])
    routeActive: any;

    ngAfterViewInit(){
      if (this.routeActive) this.routeActive.unsubscribe();
      this.routeActive = this.route.url.subscribe(() => {
        setTimeout(() => {
          this.scrollDirective.checkOnResize()
        }, 250);
      });
    }

    togglePdf(pdfId){
      if (this.isSelected(pdfId)) 
        this.sendUpdateService.removePdf(pdfId)
      else
        this.sendUpdateService.addPdf(pdfId)
    }

    isSelected(pdfId){
      return this.selectedPdfs()?.includes(pdfId)
    }

    toggleView(){
      this.sendUpdateService.toggleView();
    }

}
